import React, {Fragment} from "react";
import {Button, Dropdown, Flex, MenuProps, Segmented, Space, Tooltip} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleLeft, faGrip, faList, faPlus} from "@fortawesome/free-solid-svg-icons";
import {useCookies} from "react-cookie";
import {Category, Component as ComponentField} from "../../feature/project/setting";
import {groupBy} from "../../feature/tools";
import {ItemType} from "rc-collapse/es/interface";
import {List} from "./ListItems";
import {ViewMode} from "./ViewMode";
import Title from "antd/es/typography/Title";
import {editorRoles, WithUserPermission} from "./WithUserPermission";

export interface ComponentsProps {
    title: string,
    categories: Array<Category>
    onAddComponentClick: (id: number) => void
    onBackClick: () => void
}

export const Components = (props: ComponentsProps) => {
    const [cookies, setCookie] = useCookies(['componentView']);

    const components = props.categories.map((item, index) => {
        return {
            key: item.id,
            label: item.title,
        }
    });

    const onComponentClick: MenuProps['onClick'] = (e) => {
        props.onAddComponentClick(parseInt(e.key));
    }

    const componentsMenu = {
        items: components,
        onClick: onComponentClick,
    };

    return (
        <Fragment>
            <Flex justify={'space-between'}>

                <Space>
                    <Button type={'text'} onClick={props.onBackClick}
                            icon={<FontAwesomeIcon icon={faAngleLeft}/>}/>
                    <Title level={4} style={{margin: 0}}>{props.title}</Title>
                </Space>
                <Space>
                    <WithUserPermission roles={editorRoles}>
                        <Dropdown menu={componentsMenu} trigger={["click"]} overlayClassName={'components-menu'}>
                            <Button icon={<FontAwesomeIcon icon={faPlus}/>}>Add Component</Button>
                        </Dropdown>
                    </WithUserPermission>

                    <Segmented
                        options={[
                            {
                                value: 'list',
                                icon: <Tooltip title="List View"><FontAwesomeIcon icon={faList}/></Tooltip>
                            },
                            {
                                value: 'grid',
                                icon: <Tooltip title="Grid View"><FontAwesomeIcon icon={faGrip}/></Tooltip>
                            },
                        ]}
                        onChange={(value) => setCookie('componentView', value)}
                        value={cookies['componentView'] || 'grid'}
                    />
                </Space>
            </Flex>
        </Fragment>
    );
}

export const groupComponents = (components: Array<ComponentField>, asList: Boolean, detailsUrl: string): ItemType[] => {
    const groups: ItemType[] = []
    groupBy(components || [], (value: ComponentField) => value.category?.id || 0).forEach((value, index) => {
        groups.push({
            key: value[0].category?.id.toString(),
            label: value[0].category?.title || "",
            children: (
                <List items={value} viewMode={asList ? ViewMode.List : ViewMode.Grid}
                      path={(id) => `${detailsUrl}${id}`} simple={true}/>
            ),
            showArrow: false,
            collapsible: 'disabled'
        })
    })
    return groups
}